<template>
  <!-- 顶部导航 -->
  <van-nav-bar
    title="商场信息"
    left-arrow
    @click-left="onClickBack"
    fixed
    safe-area-inset-top
  >
    ></van-nav-bar
  >
  <div class="StoreInformation" style="padding-top: 46px">
    <van-search
      v-model="search"
      background="#f3f3f3"
      show-action
      placeholder="请输入商场名称搜索"
      @search="onSearch"
    >
      <template #action>
        <div @click="showPicker = true" style="color: rgb(150, 151, 153)">
          筛选
        </div>
      </template>
    </van-search>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model:loading="loading"
        :finished="finished"
        finished-text="没有更多了"
        v-model:error="error"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
      >
        <div v-show="total > 0">
          <span
            style="
              margin-top: 10px;
              margin-bottom: 10px;
              text-align: center;
              display: block;
              color: rgb(150, 151, 153);
              font-size: 14px;
            "
            >商场合计:{{ total }}</span
          >
        </div>
        <van-cell v-for="item in list" :key="item" @click="jump(item)">
          <div>
            <span style="color: #e57e05">{{ item.name }}</span>
            <br />
            <span>{{ item.address }}</span>
          </div>
        </van-cell>
      </van-list>
    </van-pull-refresh>
    <van-popup v-model:show="showPicker" round position="bottom">
      <van-picker
        :columns="columns"
        value-key="name"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { ref } from "vue";
import { Toast } from "vant";
import { useRoute } from "vue-router";
import { TheMallInformation } from "../../api";
import { Region } from "../../api";
export default {
  name: "StoreInformation",
  setup() {
    let route = useRoute();
    const list = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false);
    const error = ref(false);
    const pageNum = ref(1);
    const token = ref(route.query.token);
    const userid = ref(route.query.userid);
    const total = ref("");
    const search = ref("");
    const screening = ref("");
    const showPicker = ref(false);
    const columns = [];
    const onSearch = (val) => {
      pageNum.value = 1;
      total.value = 0;
      search.value = val;
      list.value = [];
      onLoad();
    };
    const onConfirm = (value) => {
      screening.value = value.id;
      showPicker.value = false;
      pageNum.value = 1;
      console.log(search.value + screening.value + "," + value.id);
      list.value = [];
      onLoad();
    };
    const onLoad = () => {
      TheMallInformation({
        token: route.query[0],
        userid: route.query[1],
        findfactor: search.value,
        screening: screening.value,
        page: pageNum.value,
        size: 20,
      })
        .then((result) => {
          if (result.data == null) {
            total.value = 0;
            Toast(result.message);
          }
          if (result.data == null) {
            Toast(result.message);
          }
          if (refreshing.value) {
            list.value = [];
            pageNum.value = 1;
            refreshing.value = false;
          }
          if (result.data != null) {
            list.value.push(...result.data.list);
            if (result.data.total == 0) {
              total.value = result.data.list.length;
            } else {
              total.value = result.data.total;
            }
            loading.value = false;
            if (result.data.hasNextPage) {
              console.log(result.data.nextPage);
              pageNum.value = result.data.nextPage;
            } else {
              finished.value = true;
            }
          } else {
            finished.value = true;
          }
        })
        .catch((err) => {
          Toast("网络错误");
          console.log(err);
          error.value = true;
          loading.value = false;
          finished.value = true;
        });
    };
    const onRefresh = () => {
      // 清空列表数据
      finished.value = false;
      pageNum.value = 1;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      loading.value = true;
      onLoad();
    };
    return {
      search,
      onSearch,
      columns,
      showPicker,
      screening,
      onConfirm,
      list,
      onLoad,
      onRefresh,
      loading,
      refreshing,
      finished,
      token,
      userid,
      pageNum,
      total,
    };
  },
  methods: {
    // 返回
    onClickBack() {
      // 跳转上一级。
      if (this.z_isTap == true || this.z_isTap == "true") {
        // console.log(111);
        this.$router.go(-1);
      } else {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          window.webkit.messageHandlers.getDataFormVue.postMessage({
            title: "333", //vue给iOS传值
          });
        } else {
          window.android.onFinish();
        }
      }
    },
    jump(item) {
      console.log(item + "ssas");
      let listData = item;
      listData.token = this.$route.query[0];
      listData.userid = this.$route.query[1];
      listData.type = "type";
      this.$router.push({
        path: "/StoreDetails",
        query: listData,
      });
    },
    getDetails() {
      Region({})
        .then((result) => {
          // this.columns.push(...result.data);
          // 循环创建iamgeList
          // if (result.data.length > 0) {
          if (result.code == 1) {
            this.columns = result.data;
          }
        })
        .catch((err) => {
          console.log(err);
          // this.finished = true;
          Toast("网络错误");
        });
    },
  },
  mounted() {
    this.getDetails();
  },
};
</script>

<style scoped>
:deep(.van-nav-bar__arrow) {
  color: black !important;
}
:deep(.van-nav-bar__title) {
  color: black !important;
}
.van-search {
  background: #f3f3f3;
}
</style>
